module.exports = __webpack_public_path__ + "img/99ca32f91afb6970065e589c49658891.png";